import { getAllUSDTPrices } from '../../cred';

export const initialConvRates = {
	convRates: {
		0: 74.01,
		2: 4.01,
		24: 30.01,
	},
};

const getConvRates = async ({ convRates }) => {
	try {
		const { status, data } = await getAllUSDTPrices();
		if (status === 1) {
			let newConvRates = {};

			data.forEach(mkt => {
				newConvRates = {
					...newConvRates,
					[mkt.market]: mkt.rate,
				};
			});

			return {
				convRates: {
					...convRates,
					...newConvRates,
				},
			};
		}
	} catch (error) {
		console.log('getAllUSDTPrices', error);
	}
	return {};
};

export const convRatesActions = {
	__getConvRates: getConvRates,
};
